import React from 'react'
import PropTypes from 'prop-types'
import { Route, Router, Switch } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { StateProvider } from '@State'
import ButterToast, { POS_TOP, POS_RIGHT } from 'butter-toast'
import { ConfigAsmtsPage } from './asmt_comps/ConfigAsmtsPage'
import { ConfigDeepLinksPage } from './deep_links_comps/ConfigDeepLinksPage'
import { ConnectResource } from './ConnectResource'
import { Homepage } from './Homepage'

export const history = createBrowserHistory()

export const setPosted = (val, dispatch) => {
  dispatch({
    type: 'linksPosted',
    payload: val,
  })
}

export const setPosting = (val, dispatch) => {
  dispatch({
    type: 'linksPosting',
    payload: val,
  })
}

const App = props => {
  const initialState = {
    hasScopedKey: props.hasScopedKey,
    coursenumToCopy: '',
    connectedCourses: props.connectedCourses,
    instrFirstName: props.instrFirstName,
    instrEmail: props.instrEmail,
    instrId: props.instrId,
    instrCourses: props.instrCourses,
    allActs: [],
    expandedAsmts: [],
    assessmentGroups: {},
    selectedAssessments: [],
    bookSections: [],
    expandedChaps: [],
    allChapIds: [],
    allSecIds: [],
    selectedSections: [],
    inCanvasSections: [],
    linksPosted: false,
    linksPosting: false,
    defaultDeductions: [['1', 'd', '1', 'point']],
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'reset':
        return {
          ...state,
          coursenumToCopy: '',
        }
      case 'loadAsmtData':
        return {
          ...state,
          assessmentGroups: action.assessmentGroups,
          allActs: action.allActs,
          expandedAsmts: action.expandedAsmts,
          connectedCourses: action.connectedCourses,
        }
      case 'loadDeepLinkData':
        return {
          ...state,
          bookSections: action.bookSections,
          allChapIds: action.allChapIds,
          allSecIds: action.allSecIds,
          expandedChaps: action.expandedChaps,
          inCanvasSections: action.inCanvasSections,
          masterCoursenum: action.masterCoursenum,
        }
      case 'coursenumToCopy':
        return {
          ...state,
          coursenumToCopy: action.coursenumToCopy,
        }
      case 'assessmentInclusion':
        return {
          ...state,
          selectedAssessments: action.payload,
        }
      case 'assessmentGroups':
        return {
          ...state,
          assessmentGroups: action.assessmentGroups,
        }
      case 'assessmentGroupSelection':
        return {
          ...state,
          selectedAssessments: action.selectedAssessments,
        }
      case 'expandAssessments':
        return {
          ...state,
          expandedAsmts: action.payload,
        }
      case 'expandChapters':
        return {
          ...state,
          expandedChaps: action.payload,
        }
      case 'inCanvasSections':
        return {
          ...state,
          inCanvasSections: action.inCanvasSections,
        }
      case 'linksPosted':
        return {
          ...state,
          linksPosted: action.payload,
        }
      case 'linksPosting':
        return {
          ...state,
          linksPosting: action.payload,
        }
      case 'modifyDeductions':
        return {
          ...state,
          defaultDeductions: action.defaultDeductions,
        }
      case 'sectionSelection':
        return {
          ...state,
          selectedSections: action.selectedSections,
        }
      case 'updateInstructorData':
        return {
          ...state,
          ...action.payload,
        }
    }
  }

  if (
    props.connectedCourses.length === 0 &&
    !window.location.pathname.includes('connect_resource')
  ) {
    let contextId = window.location.pathname.split('/')[4]
    history.replace(
      `/links/canvas_connect.instructor_setup/-/${contextId}/connect_resource${window.location.search}`
    )
  }
  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <ButterToast
        position={{ vertical: POS_TOP, horizontal: POS_RIGHT }}
        style={{ top: '65px' }}
      />
      <img
        src="/static/instructor/media/canvas-logo-lms.png"
        className="mr-4"
      />
      <span
        className="fas fa-exchange color_teal"
        style={{ fontSize: '25px' }}
      />
      <img
        src="/static/base_app/media/logos/wordmark-blue-300.png"
        className="ml-4"
      />
      <div className="container col-lg-24 mt-5">
        <Router history={history}>
          <Switch>
            <Route
              path="/links/canvas_connect.instructor_setup/:coursenum/:contextId/connect_resource"
              component={ConnectResource}
            />
            <Route
              exact
              path="/links/canvas_connect.instructor_setup/:coursenum/:contextId"
              component={Homepage}
            />
            <Route
              path="/links/canvas_connect.instructor_setup/:coursenum/:contextId/configure_assessments"
              component={ConfigAsmtsPage}
            />
            <Route
              path="/links/canvas_connect.instructor_setup/:coursenum/:contextId/configure_deep_links"
              component={ConfigDeepLinksPage}
            />
            <Route path="*" compoent={Homepage} />
          </Switch>
        </Router>
      </div>
    </StateProvider>
  )
}

App.propTypes = {
  instrEmail: PropTypes.string,
  connectedCourses: PropTypes.array,
  instrCourses: PropTypes.array,
  hasScopedKey: PropTypes.bool,
}

export default App
